/**
 * @fileoverview PUT handler for the "/engagement/:app_group_id/suppression_rules/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdSuppressionRulesIdCacheKeys } from "./constants";
import type {
  PutEngagementAppGroupIdSuppressionRulesIdProps,
  PutEngagementAppGroupIdSuppressionRulesIdResult,
} from "./types";

export const putEngagementAppGroupIdSuppressionRulesId = reactQueryMutationAdapter(
  engagementAppGroupIdSuppressionRulesIdCacheKeys,
  (
    props: PutEngagementAppGroupIdSuppressionRulesIdProps
  ): Promise<PutEngagementAppGroupIdSuppressionRulesIdResult> => {
    // The endpoint applies only the attributes present in the request, so omit the ones the
    // caller left undefined rather than sending them as null.
    const body: Record<string, unknown> = {};

    if (props.name !== undefined) {
      body.name = props.name;
    }

    if (props.enabled !== undefined) {
      body.enabled = props.enabled;
    }

    if (props.sendingDomain !== undefined) {
      body.sending_domain = props.sendingDomain;
    }

    if (props.bounceClassifications !== undefined) {
      body.bounce_classifications = props.bounceClassifications;
    }

    if (props.minDaysApart !== undefined) {
      body.min_days_apart = props.minDaysApart;
    }

    if (props.softBounceCount !== undefined) {
      body.soft_bounce_count = props.softBounceCount;
    }

    if (props.markedAsDeleted !== undefined) {
      body.marked_as_deleted = props.markedAsDeleted;
    }

    return fetch(`/engagement/${props.appGroupId}/suppression_rules/${props.id}`, "PUT", body, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
